import * as React from 'react'

export const PostalSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" aria-hidden={true} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 5.75C3.79688 5.75 3.25 6.33594 3.25 7V8.5625L10.8672 14.1875C11.5312 14.6562 12.4297 14.6562 13.0938 14.1875L20.75 8.5625V7C20.75 6.33594 20.1641 5.75 19.5 5.75H4.5ZM3.25 10.125V17C3.25 17.7031 3.79688 18.25 4.5 18.25H19.5C20.1641 18.25 20.75 17.7031 20.75 17V10.125L13.8359 15.2031C12.7422 15.9844 11.2188 15.9844 10.125 15.2031L3.25 10.125ZM2 7C2 5.63281 3.09375 4.5 4.5 4.5H19.5C20.8672 4.5 22 5.63281 22 7V17C22 18.4062 20.8672 19.5 19.5 19.5H4.5C3.09375 19.5 2 18.4062 2 17V7Z"
      fill={'#333333'}
    />
  </svg>
)
export default PostalSVG
